// src/components/calls-summary-daily-chart.tsx

import React from 'react';
import BaseCallsSummaryChart from '../base-calls-summary-chart/base-calls-summary-chart';
import { useCallSummaryData } from 'hooks/charts/call-summaries';
import { type CallSummaries } from 'src/types/call-summaries';

const CallsSummaryDailyChart: React.FC<CallSummaries> = ({ summaries }) => {
  const chartData = useCallSummaryData(summaries, 'daily');

  return (
    <BaseCallsSummaryChart
      labels={chartData.labels}
      effectiveCalls={chartData.effectiveCalls}
      missedCalls={chartData.missedCalls}
      voicemailCalls={chartData.voicemailCalls}
      // TODO: check when implementing i18n
      chartTitle="Llamadas Diarias"
    />
  );
};

export default CallsSummaryDailyChart;
